import { call, fork, put } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import SystemClient from 'rest/SystemClient';
import { errorAction } from 'components/utility/actions';
import * as actions from './actions';

const systemClient = new SystemClient();

export function doFetchSystemConfig() {
	return systemClient.getConfig();
}

export function *fetchSystemConfig(action) {
	try {
		const response = yield call(doFetchSystemConfig);
		yield put({ type: actions.FETCH_SYSTEM_CONFIG_SUCCESS, payload: response.data });
	} catch (error) {
		yield put(errorAction(actions.FETCH_SYSTEM_CONFIG_ERROR, error, action));
	}
}

export default function *sagas() {
	yield fork(takeLatest, actions.FETCH_SYSTEM_CONFIG, fetchSystemConfig);
}
